import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref, watch } from 'vue';
import MemberInfo from '../MemberItemCommon/MemberInfo.vue';
import MemberControl from '../MemberControl';
import { UserInfo } from '../../../stores/room';
import useMemberItem from './useMemberItemHooks';
import '../../../directives/vTap';

interface Props {
  userInfo: UserInfo;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'indexH5',
  props: {
    userInfo: null
  },
  setup(__props: any) {

const props = __props as {
  userInfo: UserInfo;
};



const memberItemContainerRef = ref();

const { isMemberControlAccessible, openMemberControl, closeMemberControl } =
  useMemberItem(props.userInfo);
const showMemberControl = ref(false);
watch(isMemberControlAccessible, (accessible: boolean) => {
  if (accessible === false) {
    showMemberControl.value = false;
  }
});

const handleOpenMemberControl = (event: MouseEvent | TouchEvent) => {
  event.stopPropagation();
  openMemberControl();
  if (isMemberControlAccessible.value === true) {
    showMemberControl.value = true;
  }
};

const handleDocumentTouchend = (event: any) => {
  if (memberItemContainerRef.value?.contains(event?.target)) {
    return;
  }
  closeMemberControl();
  showMemberControl.value = false;
};
onMounted(() => {
  document.addEventListener('touchend', handleDocumentTouchend);
});

onUnmounted(() => {
  document.removeEventListener('touchend', handleDocumentTouchend);
});

return { __sfc: true,props, memberItemContainerRef, isMemberControlAccessible, openMemberControl, closeMemberControl, showMemberControl, handleOpenMemberControl, handleDocumentTouchend, MemberInfo, MemberControl }
}

})